import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

const PackageUpgradeCSHP = ({ onSelectedPackage, storage, currentpackageid }) => {
    const [plans, setPlans] = useState([]);
    const [selectedTab, setSelectedTab] = useState("Basic");
    const [selectedPackageId, setSelectedPackageId] = useState(null);
    const [filteredPackages, setFilteredPackages] = useState([]);
    const [minCore, setMinCore] = useState(0);
    const [minMemory, setMinMemory] = useState(0);
    const [minStorage, setMinStorage] = useState(0);

    useEffect(() => {
        const fetchServerData = async () => {
            try {
                const token = Cookies.get("Token");

                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/api/v1/regions/vn/systems/1`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error("Failed to fetch data");
                }

                const data = await response.json();
                setPlans(data.categories.filter((category) => category.type === "plan"));
            } catch (error) {
                console.error("Error fetching server data:", error);
            }
        };

        fetchServerData();
    }, []);
    useEffect(() => {
        if (!plans.length) return;

        console.log("Plans Data:", plans);
        console.log("Selected Tab:", selectedTab);

        const selectedPackageType = plans.find((plan) => plan.name === selectedTab);
        const availablePackages = selectedPackageType?.packages || [];

        console.log("Available Packages in Current Tab:", availablePackages);

        if (availablePackages.length > 0) {
            const validPackages = availablePackages.filter(pkg => pkg.storage >= Number(storage) && pkg.id !== currentpackageid);

            if (validPackages.length > 0) {
                const lastPackage = validPackages[validPackages.length - 1];
                setSelectedPackageId(lastPackage.id);
                onSelectedPackage(lastPackage);
            } else {
                const validPlan = plans.find((plan) =>
                    plan.packages.some(pkg => pkg.storage >= Number(storage) && pkg.id !== currentpackageid)
                );

                if (validPlan) {
                    console.log("Switching to Tab:", validPlan.name);
                    setSelectedTab(validPlan.name);

                    const lastValidPackage = validPlan.packages
                        .filter(pkg => pkg.storage >= Number(storage) && pkg.id !== currentpackageid)
                        .pop();

                    if (lastValidPackage) {
                        setSelectedPackageId(lastValidPackage.id);
                        onSelectedPackage(lastValidPackage);
                    }
                }
            }
        }
    }, [selectedTab, plans, storage, currentpackageid]);



    useEffect(() => {
        if (!plans.length || storage == null) return;

        console.log("Running filter with storage:", storage);

        const selectedPackageType = plans.find((plan) => plan.name === selectedTab);
        const validPackages = (selectedPackageType ? selectedPackageType.packages : []).filter(
            (pkg) => pkg.storage >= Number(storage) && pkg.id !== currentpackageid
        );

        setFilteredPackages(validPackages);
    }, [selectedTab, plans, storage, currentpackageid]);


    const handleTabSelect = (tabName) => {
        setSelectedTab(tabName);

        const selectedPlan = plans.find((plan) => plan.name === tabName);
        const validPackages = selectedPlan?.packages.filter(pkg => pkg.storage >= Number(storage) && pkg.id !== currentpackageid) || [];

        if (validPackages.length > 0) {
            const lastValidPackage = validPackages[validPackages.length - 1];
            setSelectedPackageId(lastValidPackage.id);
            onSelectedPackage(lastValidPackage);
        } else {
            setSelectedPackageId(null);
        }
    };


    const handlePackageSelect = (pkg) => {
        setSelectedPackageId(pkg.id);
        onSelectedPackage(pkg);
    };

    const renderPackageTabs = () => (
        <div className="sv-type-list mb-2">
            <ul className="nav nav-tabs">
                {plans.map((type) => (
                    <li key={type.id} className="nav-item">
                        <button
                            className={`nav-link ${selectedTab === type.name ? "active" : ""}`}
                            onClick={() => handleTabSelect(type.name)}
                        >
                            {type.name}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );

    const renderTable = () => {
        if (plans.length === 0) {
            return <p>Đang tải trang</p>;
        }

        return (
            <div className="table-responsive">
                <table className="table table-hover table-striped">
                    <thead style={{ backgroundColor: "#007bff", color: "white" }}>
                        <tr>
                            <td style={{ fontSize: "15px", fontWeight: "bold", textAlign: "left", padding: "10px" }}>Name</td>
                            <td style={{ fontSize: "15px", fontWeight: "bold", textAlign: "center", padding: "10px" }}>Cores</td>
                            <td style={{ fontSize: "15px", fontWeight: "bold", textAlign: "center", padding: "10px" }}>Memory</td>
                            <td style={{ fontSize: "15px", fontWeight: "bold", textAlign: "center", padding: "10px" }}>Storage</td>
                            <td style={{ fontSize: "15px", fontWeight: "bold", textAlign: "center", padding: "10px" }}>Price</td>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredPackages.map((pkg) => (
                            <tr
                                key={pkg.id}
                                onClick={() => handlePackageSelect(pkg)}
                                style={{
                                    backgroundColor: selectedPackageId === pkg.id ? "#e9f7fd" : "#fff",
                                    border: selectedPackageId === pkg.id ? "2px solid #007bff" : "1px solid #e9ecef",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                    position: "relative",
                                }}
                            >
                                <td style={{ fontSize: "14px", padding: "12px", textAlign: "left", position: "relative" }}>
                                    {pkg.name}
                                </td>
                                <td style={{ fontSize: "14px", padding: "12px", textAlign: "center" }}>{pkg.core}</td>
                                <td style={{ fontSize: "14px", padding: "12px", textAlign: "center" }}>{pkg.memory}</td>
                                <td style={{ fontSize: "14px", padding: "12px", textAlign: "center" }}>{pkg.storage}</td>
                                <td style={{ fontSize: "14px", padding: "12px", textAlign: "center", position: "relative" }}>
                                    {pkg.cshp_price ? pkg.cshp_price.toLocaleString("vi-VN") : "N/A"}
                                    {selectedPackageId === pkg.id && (
                                        <>
                                            <span
                                                style={{
                                                    position: "absolute",
                                                    top: "0",
                                                    right: "0",
                                                    width: "0",
                                                    height: "0",
                                                    borderStyle: "solid",
                                                    borderWidth: "25px 0 0 25px",
                                                    borderColor: "#007bff transparent transparent transparent",
                                                }}
                                            ></span>

                                            <span
                                                style={{
                                                    position: "absolute",
                                                    top: "1px",
                                                    right: "1px",
                                                    color: "white",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                ✔
                                            </span>
                                        </>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div style={{ margin: 0, padding: 0 }} className="container">
            {renderPackageTabs()}
            {renderTable()}
        </div>
    );
};

export default PackageUpgradeCSHP;
